import { ETwoFactorAuthenticationChannel } from '../two-factor-authentication.consts';
import { TTranslationKey } from 'src/app/project/features/translate/types';

export type TMultiSelectOption = {
  labelKey: TTranslationKey;
  value: string;
};

export const twoFactorAuthenticationChannelOptions: TMultiSelectOption[] = [
  {
    labelKey: 'send_via_sms',
    value: ETwoFactorAuthenticationChannel.SMS,
  },
  {
    labelKey: 'send_via_whatsapp',
    value: ETwoFactorAuthenticationChannel.WHATSAPP,
  },
];
